import { Component, Input, OnInit, Output,EventEmitter } from '@angular/core';
import { StatePersistService } from 'src/app/core/services/state-persist.service';
import { SharedConsts } from 'src/app/shared/constants';
import { GoogleAnalyticsService } from 'src/app/shared/services/google-analytics.service';

@Component({
    selector: 'product-sorting',
    templateUrl: './product-sorting.component.html',
    styleUrls: ['./product-sorting.component.scss'],
    standalone: false
})
export class ProductSortingComponent implements OnInit {
  sortBy = 'short_desc'
  order = 'asc'
  selectedSort = 3;
  @Input() filterReset:boolean;
  @Output() hasRspFilterApplied = new EventEmitter();
  
  constructor(
    private statePersist: StatePersistService,
    private googleAnalyticsService: GoogleAnalyticsService) { }

    ngOnChanges(simple:any){
      if(simple.filterReset && simple.filterReset.currentValue){
        this.sortBy = 'short_desc';
        this.order = 'asc';
        let product_data = this.statePersist.getLocalStorage('product_data')
        product_data['sort'] = this.sortBy
        product_data['order'] = this.order;
        this.selectedSort = 3;
        this.statePersist.setLocalStorage('product_data',product_data, 'product-data-update');
      }
    }


  ngOnInit(): void {
    let product_data
    if ( this.statePersist.getLocalStorage('product_data') != null){
      product_data = this.statePersist.getLocalStorage('product_data')
      this.sortBy = product_data['sort']
      this.order = product_data['order']
      if(this.sortBy == 'rsp'){
        this.selectedSort = 1
      }
      else if (this.sortBy == 'short_desc'){
        this.selectedSort = 3
      }
      else if (this.sortBy == 'cost'){
        this.selectedSort = 2
      }
    }
  }

  productSort(selectedSort, by, order){
    if(by == 'rsp'){
      this.googleAnalyticsService.eventEmitter("prodcat_rsp_"+order+"_sort", SharedConsts.GOOGLEANALYTICSS_EVENT_CATEGORY_NAME, "rsp sort applied", SharedConsts.GOOGLEANALYTICSS_EVENT_LABEL, SharedConsts.GOOGLEANALYTICSS_EVENT_VALUE);
    }
    else{
      this.googleAnalyticsService.eventEmitter("ProdCat_short_description_"+order+"_sort", SharedConsts.GOOGLEANALYTICSS_EVENT_CATEGORY_NAME, "short description sort applied", SharedConsts.GOOGLEANALYTICSS_EVENT_LABEL, SharedConsts.GOOGLEANALYTICSS_EVENT_VALUE);
    }

    if(this.selectedSort !== selectedSort){
      this.order = "desc"
    }
    
    this.selectedSort = selectedSort
    this.sortBy = by
    var sortorder;
    sortorder = this.order == 'desc' ? 'asc' : 'desc';
    this.order  = sortorder
    this.applySort()
  }

  applySort(){
    let product_data
    if ( this.statePersist.getLocalStorage('product_data') != null){
      product_data = this.statePersist.getLocalStorage('product_data')
      product_data['sort'] = this.sortBy
      product_data['order'] = this.order
      this.statePersist.setLocalStorage('product_data',product_data, 'product-data-update')
    }
    else{
      this.statePersist.setLocalStorage('product_data',{'sort':this.sortBy, 'order':this.order
      });
    }
    window.scroll({ 
      top: 0, 
      left: 0, 
      behavior: 'smooth' 
    });
    this.hasRspFilterApplied.emit('true');
  }

}
